//shortcut

export * from '@lnw/util'
export default from '@lnw/util'
